import { render } from "./Aiprivacy.vue?vue&type=template&id=d7dd423c&scoped=true"
import script from "./Aiprivacy.vue?vue&type=script&lang=js"
export * from "./Aiprivacy.vue?vue&type=script&lang=js"

import "./Aiprivacy.vue?vue&type=style&index=0&id=d7dd423c&scoped=true&lang=css"

import exportComponent from "/Users/liusx/Projects/pc-web-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7dd423c"]])

export default __exports__